const isPageEditor = function () {
    return (
        window.Sitecore !== undefined &&
        window.Sitecore.PageModes !== undefined &&
        window.Sitecore.PageModes.PageEditor !== undefined);
};

export const ifExist = (element) => {
    const elem = document.querySelector(element);
    if ((typeof (elem) != 'undefined' && elem != null) || isPageEditor()) {

        return true;
    }
    return false;
};

export const ifExistOnly = (element) => {
    const elem = document.querySelector(element);
    if (typeof (elem) != 'undefined' && elem != null) {
        return true;
    }
    return false;
};